import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldAlert, RefreshCw, LogOut, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import DiamondMark from "@/components/DiamondMark";

export default function AwaitingApproval() {
  const { checkAuth, logout } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  const recheck = async () => {
    setBusy(true);
    await checkAuth();
    setBusy(false);
  };
  const signOut = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  return (
    <div data-testid="awaiting-approval" className="min-h-screen bg-bd-black grain flex items-center justify-center px-6">
      <div className="w-full max-w-lg text-center">
        <DiamondMark size={40} className="mx-auto mb-8" />
        <div className="bg-bd-charcoal border border-white/10 p-8 md:p-12">
          <div className="w-16 h-16 mx-auto mb-6 rounded-full border border-bd-gold/40 flex items-center justify-center">
            <ShieldAlert size={28} className="text-bd-gold" />
          </div>
          <p className="overline text-bd-gold mb-3">Device pending approval</p>
          <h1 className="font-serif text-3xl text-bd-ivory mb-4">This device is awaiting approval</h1>
          <p className="text-sm text-bd-ivory/60 leading-relaxed">
            For your security, sign-ins from a new device must be approved before the dashboard can be opened.
            We've emailed the account owner an approval link — approve this device from that email
            (or from the Security page on a trusted device), then check again here.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-8">
            <button data-testid="awaiting-recheck" onClick={recheck} disabled={busy}
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-bd-gold text-bd-black hover:bg-bd-gold2 transition-colors duration-300 px-8 py-3.5 text-sm tracking-[0.15em] uppercase disabled:opacity-60">
              {busy ? <Loader2 size={16} className="animate-spin" /> : <RefreshCw size={16} />} Check again
            </button>
            <button data-testid="awaiting-signout" onClick={signOut}
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 border border-white/20 text-bd-ivory/70 hover:border-bd-gold hover:text-bd-gold transition-colors duration-300 px-8 py-3.5 text-sm tracking-wide">
              <LogOut size={16} /> Sign out
            </button>
          </div>
        </div>
        <p className="mt-8 text-xs text-bd-ivory/30 leading-relaxed">
          If you did not attempt to sign in, block this device from the alert email to secure the account.
        </p>
      </div>
    </div>
  );
}
